/*       */

import React, { useMemo, useCallback } from 'react';
import { Autocomplete } from '@mic3/platform-ui';
import { DOMParser } from '@xmldom/xmldom';

const SignalTypeahead = ({ value: definition, data, onChange, ...restProps }) => {
    const options = useMemo(() => {
        const doc = new DOMParser().parseFromString(definition);
        const signals = doc.getElementsByTagName('signal');
        return Array.from(signals).map(elem => {
            return {
                value: elem.getAttribute('id'),
                label: elem.getAttribute('name'),
            };
        });
    }, [definition]);

    const handleOnChange = useCallback(
        ({ target: { value, name } }) => {
            const doc = new DOMParser().parseFromString(definition);
            const parenElement = doc.getElementById(data.id);
            const signalEvent = parenElement.getElementsByTagName('signalEventDefinition')[0];
            if (!value) {
                signalEvent.removeAttribute('signalRef');
            } else {
                signalEvent.setAttribute('signalRef', value);
            }
            onChange({ target: { value: String(doc), name } });
        },
        [data.id, definition, onChange]
    );

    const value = useMemo(() => {
        const doc = new DOMParser().parseFromString(definition);
        const parenElement = doc?.getElementById(data.id);
        const signalEvent = parenElement?.getElementsByTagName('signalEventDefinition')[0];
        if (!signalEvent) {
            return null;
        }
        return signalEvent.getAttribute('signalRef') || null;
    }, [data.id, definition]);

    return <Autocomplete {...restProps} value={value} onChange={handleOnChange} options={options} valueField="value" />;
};

export default SignalTypeahead;
